import Botao from 'componentes/Botao';
import React from 'react';

import style from './Modal.module.scss';

export default function Modal({isOpen, setOpenModal, children}) {
  
  if(isOpen){
    return (
      <div className={style.background}>
        <div className={style.modal}>         
          <div>
            {children}
          </div>
          <div>            
            <Botao tipo="button" cliqueBotao={setOpenModal} >Fechar</Botao>           
          </div>
        </div>    
      </div>
    )
  } else{
    return null;
  }
  
}